import { TwoFAState } from '@pages/profile-security/store/state/two-fa.state';
import { MultiFAState } from '@pages/profile-security/store/state/multi-fa.state';

export const profileSecurityState = [TwoFAState, MultiFAState];
